import React from "react";

const Page3 = () => {
  return (
    <div className=" pt-10 md:pt-0 px-5 pb-4 bg-white  overflow-hidden">
      <div className="h-full min-h-[95vh] w-full overflow-hidden bg-black rounded-[50px] md:rounded-[50px] relative flex flex-col lg:flex-row items-center justify-center p-8 md:p-16">
        
        {/* Background Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover opacity-60"
          src="/file.mp4"
        />

        {/* Content Wrapper */}
        <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {/* Left side - Image */}
          <div className="w-full lg:w-1/2 flex pt-4 justify-center lg:justify-end">
            <div className="w-[280px] h-[280px] sm:w-[350px] sm:h-[350px] lg:w-[450px] lg:h-[450px] rounded-3xl overflow-hidden shadow-2xl border-4 border-white/10">
              <img
                src="/profile1.jpeg"
                alt="Akshita Laddha"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right side - Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            {/* Name section */}
            <div className="mb-6 md:mb-8">
              <h2 className="text-4xl sm:text-5xl lg:text-9xl font-bold font-[anzo] text-blue-300 mb-4 lg:mb-6 leading-tight">
                I'm Akshita Laddha
              </h2>
              <div className="flex flex-wrap justify-center lg:justify-start gap-3 md:gap-4 mb-6 md:mb-8">
                <span className="px-4 py-2 md:px-6 md:py-3 text-sm md:text-lg bg-white/15 backdrop-blur-md rounded-full text-white/90 font-medium  border border-white/25 hover:bg-white/25 transition-all">
                  Full-Stack Developer
                </span>
              </div>
            </div>

            {/* Description */}
            <div className="max-w-2xl mx-auto lg:mx-0">
              <p className="text-base md:text-lg lg:text-xl text-justify text-white/90 font-light leading-relaxed opacity-90">
                I'm Software developer and I believes in solving problems with code. I focus on Next.js, Node.js, and Typescript, and I love building scalable web applications. So far I have worked on projects like PDF Management System and Expense Tracker, where I learned to handle complex logic and smooth UI. <br></br>
                Currently, I’m building something really exciting: An Streaming application and AI powered application. My goal is to bridge the gap between seamless content delivery and intelligent user experiences. I enjoy turning ideas into functional applications and aspire to
                contribute as a software developer, creating solutions that make a
                real impact.
              </p>
            </div>

            {/* Decorative Elements - Hidden on small mobile for cleaner look */}
            {/* <div className="mt-10 hidden sm:flex items-center justify-center lg:justify-start space-x-4">
              <div className="w-16 md:w-24 h-1 bg-gradient-to-r from-blue-400 to-transparent"></div>
              <div className="w-3 h-3 bg-blue-400 rounded-full animate-pulse"></div>
              <div className="w-12 md:w-16 h-1 bg-gradient-to-r from-blue-400/50 to-transparent"></div>
            </div> */}
          </div>
        </div>

        {/* Floating Elements (Responsive visibility) */}
        <div className="absolute top-1/4 right-1/4 w-1.5 h-1.5 bg-blue-400/40 rounded-full animate-bounce hidden md:block"></div>
        <div className="absolute bottom-1/4 left-1/4 w-2 h-2 bg-purple-400/20 rounded-full animate-pulse hidden md:block"></div>
      </div>
    </div>
  );
};

export default Page3;